'use client';

import { c as _c } from "react/compiler-runtime";
import AnimateLines from '@components/animate-lines/AnimateLines';
import { CommonButton } from '@components/common-button/CommonButton';
import ParallaxMedia from '@components/parallax-media/ParallaxMedia';
import whiteBox from '@images/renders/architecture_images/whiteBox2.webp';
import ROUTES from '@lib/constants/routes';
import gsap from 'gsap/all';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useRouter } from 'next/navigation';
import { useLayoutEffect, useRef, useState } from 'react';
import style from './WhiteBoxGeneral.module.scss';
import WhiteBoxList from './WhiteBoxList';
gsap.registerPlugin(ScrollTrigger);
function WhiteBoxGeneral(t0) {
  const $ = _c(15);
  const {
    isMobile
  } = t0;
  const [toggle, setToggle] = useState(false);
  const svgRef = useRef(null);
  const router = useRouter();
  let t1;
  let t2;
  if ($[0] !== isMobile) {
    t1 = () => {
      if (svgRef) {
        let st = null;
        const element = svgRef.current;
        setTimeout(() => {
          st = ScrollTrigger.create({
            trigger: element,
            start: "top top",
            scroller: !isMobile ? "#smooth-wrapper" : "body",
            duration: 2,
            scrub: true,
            pin: false,
            onToggle: () => {
              setTimeout(() => {
                setToggle(true);
              }, 500);
            }
          });
          return () => {
            st.kill();
          };
        }, 500);
      }
    };
    t2 = [svgRef, isMobile];
    $[0] = isMobile;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useLayoutEffect(t1, t2);
  let t3;
  if ($[3] !== toggle) {
    t3 = <div className={style.svgLineBox} ref={svgRef}><AnimateLines id="white-box-general" className={style.svgLine} toggle={toggle} /></div>;
    $[3] = toggle;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className={style.title}>Предчистовая отделка</p>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className={style.imageBox}><ParallaxMedia className={style.image} src={whiteBox} name={"\u041F\u0440\u0435\u0434\u0447\u0438\u0441\u0442\u043E\u0432\u0430\u044F \u043E\u0442\u0434\u0435\u043B\u043A\u0430"} imagePlug={whiteBox} height="100%" /></div>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== isMobile) {
    t6 = <WhiteBoxList isMobile={isMobile} />;
    $[7] = isMobile;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== router) {
    t7 = <CommonButton text={"\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435 \u043E \u043F\u0440\u0435\u0434\u0447\u0438\u0441\u0442\u043E\u0432\u043E\u0439 \u043E\u0442\u0434\u0435\u043B\u043A\u0435"} className={style.button} handleFunction={() => router.push(ROUTES.whitebox)} />;
    $[9] = router;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t3 || $[12] !== t6 || $[13] !== t7) {
    t8 = <div className={style.wrapper}>{t3}{t4}{t5}{t6}{t7}</div>;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}
export default WhiteBoxGeneral;